<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>退货退款管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="订单编号">
          <el-input size="small" clearable v-model="formInline.outTradeNo" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select size="small" clearable v-model="formInline.auditState" placeholder="请选择审核状态">
            <el-option
                v-for="company in audit"
                :key="company.value"
                :label="company.key"
                :value="company.value"
              ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select size="small" clearable v-model="formInline.tradeState" placeholder="请选择订单状态">
            <el-option
              v-for="company in paywayOption"
              :key="company.value"
              :label="company.key"
              :value="company.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后原因">
          <el-select size="small" clearable v-model="formInline.reason" placeholder="请选择售后原因">
            <el-option
              v-for="item in reasonOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
            <el-date-picker
            size="small"
            v-model="dateRange"
            type="daterange"
            @change="dateChange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="outTradeNo" label="订单编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productName" label="商品名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="orderMoney" label="订单金额" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="shoppingUserName" label="收货人" show-overflow-tooltip>
        </el-table-column>
        <el-table-column sortable label="审核状态" show-overflow-tooltip>
            <template slot-scope="scope">
            {{ getAuditState(scope.row.auditState) }}
          </template>
        </el-table-column>
        <el-table-column label="原因" show-overflow-tooltip>
            <template slot-scope="scope">
            {{ scope.row.reason}}
          </template>
        </el-table-column>
        <el-table-column label="订单状态" show-overflow-tooltip>
            <template slot-scope="scope">
            {{ getStatus(payway,scope.row.tradeState) }}
            </template>
        </el-table-column>
        <el-table-column sortable prop="createDate" label="创建时间" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{scope.row.createDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column sortable prop="updateDate" label="更新时间" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{scope.row.updateDate|timestampToTime}}</div>
          </template>
        </el-table-column>
        <el-table-column label="相关图片">
            <template slot-scope="scope">
                <el-image
                    v-for="imgoss in scope.row.imageUrlOss"
                    :key="imgoss"
                    class="imgarea"
                    style="width: 80px; height: 50px"
                    :src=imgoss
                    :preview-src-list=scope.row.imageUrlOss>
                    <div slot="error" class="image-slot">
                        <i>———————</i>
                    </div>
                </el-image>
            </template>
        </el-table-column>
        <el-table-column label="供应商确认收货" prop="refundGoodState" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="btn-area" v-if="scope.row.refundGoodState == '0'">
                <el-button size="mini" type="primary" plain @click="refundGoodFun(scope.row)">确认</el-button>

            </div>
            <div class="btn-area" v-if="scope.row.refundGoodState == '1'">
              已确认
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核" fixed="right" min-width="150">
            <template slot-scope="scope">
                <!-- <el-switch
                    :disabled="scope.row.tradeState !== 'REFUNDGOODING'"
                    v-model="scope.row.auditState"
                    :active-value="0"   :inactive-value="1"
                    active-text="同意" inactive-text="拒绝"
                    @change="editState($event, scope.row)">
                </el-switch> -->
                <div class="btn-area" v-if="scope.row.tradeState == 'REFUNDGOODING'">
                  <el-button size="mini" type="primary" plain @click="editState(0, scope.row)">同意</el-button>
                <el-button size="mini" type="danger" plain @click="editState(1, scope.row)">拒绝</el-button>
                </div>

            </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>

  <script>
  import { OrderRefund, auditOrder, confirm} from '../../api/payMG'
  import {timestampToTime} from '../../utils/util'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        companyOption:[],
        audit:[{key:'同意',value:0},
                {key:'拒绝',value:1}],
        payway: [
        { key: '待付款', value: 'PAID' },
        { key: '待发货', value: 'SHIPPED' },
        { key: '待收货', value: 'RECEIVED' },
        // { key: '待评价', value: 'EVALUATED' },
        { key: '已取消', value: 'CANCEL' },
        { key: '支付失败', value: 'PAYERROR' },
        { key: '退货退款中', value: 'REFUNDGOODING' },
          {key:'退款中',value:'REFUNDING'},
        { key: '退货退款成功', value: 'REFUNDGOOD' },
        { key: '退货退款失败', value: 'REFUNDGOODERR' },
        { key: '退款成功', value: 'REFUND' },
          { key: '订单完成', value: 'POSTSALE' },
      ],
        // 订单状态（新条件）REFUNDGOODING-退款中，REFUND-退款成功，REFUNDGOOD-退货退款成功，REFUNDGOODERR-退款退货失败
        paywayOption:[
          { key: '退款中', value: 'REFUNDGOODING' },
          { key: '退款成功', value: 'REFUND' },
          { key: '退货退款成功', value: 'REFUNDGOOD' },
          { key: '退款退货失败', value: 'REFUNDGOODERR' },
        ],
        reasonOptions:[
          {
            text: '拍错/多拍/不喜欢',
            value: '0',
            disable: false
          },
          {
            text: '卖家承诺发货时间、提货地点不符',
            value: '1',
            disable: false
          },
          {
            text: '卖家发错货',
            value: '2',
            disable: false
          },
          {
            text: '假冒品牌',
            value: '3',
            disable: false
          },
          {
            text: '收到商品少件/破损/污渍等',
            value: '4',
            disable: false
          },
          {
            text: '质量问题',
            value: '5',
            disable: false
          }
        ],
        dateRange:null,
        editForm: {
          id: '',
        },
        formInline: {
          page: 1,
          limit: 10,
          // startDate: timestampToTime(new Date()),
          // endDate: timestampToTime(new Date()),
          startDate: '',
          endDate: '',
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    created() {
      this.getdata(this.formInline);
    },
    methods: {
      getAuditState(v){
        if(v==0 || v==1){
          return v==0 ? '同意' : '拒绝'
        }else{
          return '————'
        }
      },
      dateChange(v){
        this.formInline.startDate	= v[0]
        this.formInline.endDate	= v[1]
      },
      // 获取表格数据
      getdata(parameter) {
        this.loading = true
        OrderRefund(parameter)
          .then(res => {
            this.loading = false
            if (res.rsp_code !== 200) {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
            } else {
              this.listData = res.body.records
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.body.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page=1
        this.getdata(this.formInline)
      },
      //确认收货操作
      refundGoodFun(row) {
        this.$confirm('是否确认收货?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let par = {
            id:row.id,
          }
          confirm(par).then(res => {
            if (res.rsp_code==200) {
              this.$message({
                type: 'success',
                message: '成功确认!'
              })
              this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
              // row.auditState = row.auditState==0?1:0
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error('确认收货失败，请联系管理员')
            })
        })
          .catch(() => {
            if(row.auditState==null){
              row.auditState = null
            }else{
              row.auditState = row.auditState === 0 ? 1 : 0;
            }
          })
      },
      // 操作审核
      editState(state, row) {
        let text =state == 0? '同意':'拒绝';
        this.$confirm('确定要'+text+'退款吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let par = {
              auditState:state,
              orderId:row.orderId,
              id:row.id,
            }
            auditOrder(par).then(res => {
                if (res.rsp_code==200) {
                  this.$message({
                    type: 'success',
                    message: '审核成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                  row.auditState = row.auditState==0?1:0
                }
              })
              .catch(err => {
                this.loading = false
                row.auditState = row.auditState==0?1:0
                this.$message.error('审核失败，请稍后再试！')
              })
          })
          .catch(() => {

          })
      },
      getStatus(statusOption,statusName){
         let statusObj = statusOption.filter( statusItem => statusName == statusItem.value )
         return statusObj[0].key
      }
    }
  }
  </script>

  <style scoped>
  .el-select{
    width: 100%;
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .btn-area{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  </style>







// WEBPACK FOOTER //
// src/views/pay/refund.vue